// components/Templates/index.js
export { default as AppShell } from './AppShell';
export { default as AuthBody } from './AuthBody';
export { default as PageHeader } from './PageHeader';
export { default as PageBody } from './PageBody';
